import { render, staticRenderFns } from "./BlocoInserirManualmenteCertificacao.vue?vue&type=template&id=0c001701&lang=pug"
import script from "./BlocoInserirManualmenteCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoInserirManualmenteCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInserirManualmenteCertificacao.vue?vue&type=style&index=0&id=0c001701&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports